import React, { FC } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';

interface IInputSelect {
  controlId: string;
  label: string;
  placeholder: string;
  handleChange: any;
  handleBlur: any;
  errorsField?: any;
  touched?: any;
  selected: any;
  options: any;
  readOnly?: any;
  disabled?: any;
  setValue: any;
}

const InputSelectMultipleAutocomplete: FC<IInputSelect> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleBlur,
  errorsField,
  touched,
  selected,
  options,
  readOnly,
  disabled,
  setValue,
}) => {
  const isAllSelected = options ? options.length > 0 && selected.length === options.length : false;
  

  const emptyArray: any = [];
  let updatedOptions = []
  if(options.length){
    
     updatedOptions = [{ key: 'all', value: 'Select All' }, ...options];
  }

  handleChange = (event: any, value: any) => {
   

  //  const optionsValues = options.map((op: any) => op.value);
 // const optionsValues = options.flatMap(op => (op.value !== 'All Machine' ? [op.value] : []));
 if (value.some((option) => option.value === 'Select All')) {   
 
      setValue(options);
      return;
    }
   
    setValue(value);

  };

  return (
    <>
   
      <Autocomplete
        multiple
        id="country-select-demo"
        autoHighlight
  
        options={updatedOptions}
        value={selected}
        onChange={(e,value)=>handleChange(e,value)}
        onBlur={handleBlur}
        disableCloseOnSelect
        getOptionLabel={(option) => option.value}
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            {option.value}
          </Box>
        )}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            placeholder={placeholder}
            error={errorsField && touched}
            style={{ zIndex: 9 }} 
            helperText={errorsField && touched ? errorsField : ''}
          />
        )}
      />
    </>
  );
};

export default InputSelectMultipleAutocomplete;
